import React from 'react';
import { closeModal } from '@components/modal';
import translate from '@data/translations';

interface DeleteProps {
    actionForYes?: Function | null;
    actionForNo?: Function;
    buttons?: any;
    content?: any;
    title?: string;
}

function Delete(props: DeleteProps) {
    const yesHandler = async () => {
        if (props.actionForYes) {
            try {
                await props.actionForYes();
            } finally {
                closeModal();
            }
        }
    };

    const noHandler = async () => {
        try {
            if (props.actionForNo) {
                await props.actionForNo();
            }
        } finally {
            closeModal();
        }
    };

    let buttons = [];
    if (props.buttons) {
        buttons = props.buttons;
    } else {
        buttons = [
            <div key={2} onClick={() => noHandler()} className="button-light mr-8p">
                {translate('No')}
            </div>,
            <div key={1} onClick={() => yesHandler()} className="button-primary ml-8p">
                {translate('Yes')}
            </div>,
        ];
    }

    return (
        <div>
            <div className="text-center ">
                {props.content ? translate(props.content) : <div>{props.title ? translate(props.title) : translate('Are you sure you want to delete?')}</div>}
                <div className="flex-center-center my-standard mt-16p">{buttons}</div>
            </div>
        </div>
    );
}

export default Delete;

//required props
//content nije required
//showOnlyCloseButton nije required
